import React, { useEffect, useRef, useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { appInfo } from './app-info';
import { appRoutes } from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { getPermissions } from './utils/authUtils';
import { useUser } from './contexts/user';
import appUpdateService from './services/AppUpdateService';

export const Content = () => {
  const { instance, accounts } = useMsal();
  const { updateUserInfo } = useUser();
  const permissionsLoaded = useRef(false);
  const appServiceInitialized = useRef(false);

  // Memoize the account to prevent unnecessary re-renders
  const currentAccount = useMemo(() => {
    return accounts && accounts.length > 0 ? accounts[0] : null;
  }, [accounts]);

  // Initialize app update service only once
  useEffect(() => {
    if (!appServiceInitialized.current) {
      appServiceInitialized.current = true;
      appUpdateService.initialize().catch(error => {
        console.error('Failed to initialize app update service:', error);
        appServiceInitialized.current = false;
      });
    }
  }, []); // Empty dependency array - run only once

  // Load permissions only once when authentication is ready and stable
  useEffect(() => {
    if (instance && currentAccount && !permissionsLoaded.current) {
      // Small delay to ensure MSAL is fully ready
      const timeoutId = setTimeout(() => {
        if (!permissionsLoaded.current) {
          permissionsLoaded.current = true;
          getPermissions(instance, accounts, updateUserInfo).catch(error => {
            console.error('Failed to load permissions:', error);
            permissionsLoaded.current = false; // Reset on error so it can retry
          });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [instance, currentAccount, updateUserInfo]); // Use currentAccount instead of accounts

  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {appRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path='*' element={<Navigate to='/home' />} />
      </Routes>
    </SideNavBarLayout>
  );
};
